import {graphql} from 'react-relay';

/** Reads who currently holds a report's edit lock, without attempting to claim it. Kept in its own
 * module (rather than inline in `HttpReportDataSource`) so a test can mock it away instead of pulling
 * relay-compiler's generated artifact into the module graph, the same reasoning as the mutation
 * modules beside it. */
const ReportLockStatusQuery = graphql`
	query ReportLockStatusQuery($reportId: ID!) {
		viewer {
			reportLockStatus(reportId: $reportId) {
				locked
				heldByViewer
				holder {
					id
					fullName
					profilePictureId
				}
				lockedAt
				expiresAt
			}
		}
	}
`;

export default ReportLockStatusQuery;
